import { Injectable } from '@angular/core';
import { RestApiService, PaginatedResponse } from './rest-api.service';
import { map, Observable } from 'rxjs';
import { BlockchainBulkStatus, BlockchainSetting } from '../models/app.model';

@Injectable({
  providedIn: 'root'
})
export class ApiBlockchainSettingService extends RestApiService {

  public apiGetObjects(params: any = {}): Observable<PaginatedResponse<BlockchainSetting>> {
    return this.getList('blockchain-settings/', BlockchainSetting.parse, params);
  }

  public apiGetObject(id: any, params: any = {}): Observable<BlockchainSetting> {
    return this.getSingle(`blockchain-settings/${id}/`, BlockchainSetting.parse, params);
  }

  public apiGetByCompany(params: any = {}): Observable<BlockchainSetting> {
    return this.getSingle('blockchain-settings/get-by-company/', BlockchainSetting.parse, params);
  }

  public apiPatchObject(id: any, payload: any, params: any = {}): Observable<BlockchainSetting> {
    return this.patchSingle(`blockchain-settings/${id}/`, payload, BlockchainSetting.parse, params);
  }

  /**
   * Effective blockchain-enabled status + root wallet balance for a batch of companies in one call.
   * `companyIds` is sent as the comma-separated `company_id__in` filter; ids the caller can't access
   * (or that fall outside the current app) are silently omitted from the response.
   */
  public apiGetBulkStatus(companyIds: (number | string)[], params: any = {}): Observable<BlockchainBulkStatus[]> {
    const mergedParams = { ...params, company_id__in: companyIds.join(',') };

    return this.getRaw('blockchain-settings/bulk-status/', mergedParams).pipe(
      map(res => {
        const data: BlockchainBulkStatus[] = [];
        for (const item of (res?.data ?? [])) {
          const parsed = BlockchainBulkStatus.parse(item);
          if (parsed !== null) { data.push(parsed); }
        }
        return data;
      })
    );
  }
}
